import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { useFact } from "@/lib/factoryI18n";

const STATUSES = ["In production", "Ready at vendor end", "Delayed"];

export default function VendorFollowup() {
  const { lang } = useLang();
  const f = useFact(lang);
  const [rows, setRows] = useState([]);
  const [openId, setOpenId] = useState("");
  const [status, setStatus] = useState("In production");
  const [expectedDate, setExpectedDate] = useState("");
  const [note, setNote] = useState("");

  const load = () => api.get("/factory/vendor-followups").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const log = async (line) => {
    if (status === "Delayed" && !expectedDate) { alert("Delayed → expected date required."); return; }
    await api.post("/factory/vendor-followups", {
      client_order_line_id: line.id, vendor_id: line.vendor_id,
      vendor_status: status, expected_date: expectedDate || null, note,
    });
    setOpenId(""); setStatus("In production"); setExpectedDate(""); setNote("");
    load();
  };

  const stale = rows.filter((r) => r.stale);

  return (
    <div data-testid="vendor-followup">
      <h1 className="text-2xl font-bold mb-2" style={{ color: "var(--brand-navy)", fontFamily: "'Fraunces', serif" }}>{f("vendor_followup")}</h1>
      <div className="text-xs text-[#7C8E9E] mb-4"><b>{stale.length}</b> line(s) unfollowed 7+ days</div>
      <div className="space-y-2">
        {rows.map((r) => (
          <div key={r.id} className={`bg-white border rounded-lg p-3 ${r.stale ? "border-red-300 bg-red-50" : "border-[#1B3A5C]/10"}`} data-testid={`follow-row-${r.id}`}>
            <div className="flex items-center justify-between gap-3 flex-wrap">
              <div className="text-sm">
                <div className="font-semibold">{r.sku || r.po_sku_key || r.id.slice(0, 8)} · {r.collection || ""}</div>
                <div className="text-xs text-[#7C8E9E]">Outstanding: {r.outstanding_qty} · Vendor: {r.vendor_id || "—"}</div>
                {r.last_followup && <div className="text-xs mt-1">Last: {r.last_followup.vendor_status} · {r.last_followup.note || ""}</div>}
              </div>
              <div className="text-right">
                <div className={`text-xs ${r.stale ? "text-red-700 font-semibold" : "text-[#7C8E9E]"}`} data-testid={`follow-days-${r.id}`}>{r.days_since_update}d</div>
                <button data-testid={`follow-open-${r.id}`} onClick={() => setOpenId(openId === r.id ? "" : r.id)} className="mt-1 px-3 py-1 rounded-full text-xs font-semibold" style={{ background: "var(--brand-gold)", color: "var(--brand-navy)" }}>{f("log_followup")}</button>
              </div>
            </div>
            {openId === r.id && (
              <div className="mt-3 border-t border-[#1B3A5C]/10 pt-3 flex flex-wrap gap-2 items-end" data-testid={`follow-form-${r.id}`}>
                <select data-testid={`follow-status-${r.id}`} value={status} onChange={(e) => setStatus(e.target.value)} className="h-9 px-2 border border-[#1B3A5C]/15 rounded-md text-sm">
                  {STATUSES.map((s) => <option key={s}>{s}</option>)}
                </select>
                {status === "Delayed" && (
                  <input data-testid={`follow-date-${r.id}`} type="date" value={expectedDate} onChange={(e) => setExpectedDate(e.target.value)} className="h-9 px-2 border border-[#1B3A5C]/15 rounded-md text-sm" />
                )}
                <input data-testid={`follow-note-${r.id}`} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Note" className="flex-1 h-9 px-2 border border-[#1B3A5C]/15 rounded-md text-sm" />
                <button data-testid={`follow-submit-${r.id}`} onClick={() => log(r)} className="h-9 px-3 rounded-full text-xs font-semibold" style={{ background: "var(--brand-navy)", color: "white" }}>Save</button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
